import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Redux/store';
import { AppDispatch } from '../Redux/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
